import { useSelector } from "react-redux";
import "./AdUser.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import { FiSearch } from "react-icons/fi";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import app from "../../../utils/firebase";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { FaSave } from "react-icons/fa";
import { IoClose, IoDocumentTextSharp } from "react-icons/io5";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { GridLoader, ScaleLoader } from "react-spinners";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { MdAdd, MdClose, MdDelete, MdEmail, MdPhone } from "react-icons/md";
import { fetchClientsBySearch } from "../../../utils/genericFunctions.js";
import { CiImageOn } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import AdUserSign from "../adUserSign/AdUserSign.jsx";

const AdUser = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  const [uploadTarget, setUploadTarget] = useState("firebase");
  const navigate = useNavigate();
  const userFullNameRef = useRef(null);

  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userRoles, setUserRoles] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [branches, setBranches] = useState([]);
  const [entityServices, setEntityServices] = useState([]);
  const [currencyAction, setCurrencyAction] = useState("");
  const [templateView, setTemplateView] = useState("list");
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const { docid } = useParams();
  const [userDocId, setUserDocId] = useState(null);
  const [userData, setUserData] = useState(null);
  const [img, setImg] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [searchTermRole, setSearchTermRole] = useState("");
  const [userPw, setUserPw] = useState(null);
  const [userConfirmPw, setUserConfirmPw] = useState(null);
  const [usrFavouriteMenus, setUsrFavouriteMenus] = useState([]);
  const [usrWidgets, setUsrWidgets] = useState([]);
  // // user fields
  // const [usrUn, setUsrUn] = useState(null);
  // const [usrFullName, setUsrFullName] = useState(null);
  // const [usrEmail, setUsrEmail] = useState(null);
  // const [usrPhotoUrl, setUsrPhotoUrl] = useState(null);
  // const [img, setImg] = useState(null);
  // const [usrPhoneNo, setUsrPhoneNo] = useState(null);
  // const [usrUnitCode, setUsrUnitCode] = useState(null);
  // const [usrProfileCode, setUsrProfileCode] = useState(null);
  // const [usrEnabled, setUsrEnabled] = useState(null);
  // const [usrEntityCode, setUsrEntityCode] = useState(null);
  const [showAddRoles, setShowAddRoles] = useState(false);
  const [systemRoles, setSystemRoles] = useState([]);
  const [userTraceData, setUserTraceData] = useState([]);
  const [isErrorsDialogOpen, setIsErrorsDialogOpen] = useState(false);
  const [errorDialogTitle, setErrorDialogTitle] = useState("Note");
  const [createUserErrors, setCreateUserErrors] = useState([]);
  const [reportGroupArray, setReportKeysArray] = useState(["users-reports"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
    param1: "",
  });



  const fetchUser = async (userDocid) => {
    try {
      if (userDocid) {
        setIsLoading(true);
        const res = await newRequest.get(`/adUser/find/${userDocid}`);
        // console.log(`fetchUser  ${JSON.stringify(res.data, null, 2)}`);
        setUserData(res.data);
        setUserDocId(res.data?._id);
        await fetchUserRoles(res.data?._id);
        await fetchUserTrace(res.data?._id);
        await fetchUserRoles(res.data?._id);
        setIsLoading(false);
        if (userFullNameRef.current) {
          userFullNameRef.current.focus();
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const fetchUserTrace = async (userDocid) => {
    try {
      const res = await newRequest.post("/trace/findUser", { user_docid: userDocid });
      setUserTraceData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUserRoles = async (userDocid) => {
    try {
      const res = await newRequest.get(`/adUserRole/userRoles/${userDocid}`);
      setUserRoles(res.data.roles);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await newRequest.post("/adRole/findAll", { role_org_code: currentUser.usr_org_code });
      let roles = [];
      if (userData?.usr_sub_agent === "Y") {
        roles = res.data.filter((val) => val?.role_entity === "Y");
      } else {
        roles = res.data;
      }
      setSystemRoles(roles);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchServiceTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Service Type", });

      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));

      setEntityServices(options);
    } catch (error) {
      console.error("Error fetching type types:", error);
    }
  };

  const fetchProfiles = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.get("/adProfile/findAll");

      const options = res.data.map((pf) => ({
        value: pf?.pf_code,
        label: pf?.pf_name,
      }));

      setProfiles(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBranches = async () => {
    try {
      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
      const options = res.data.map((branch) => ({
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));
      setBranches(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };



  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "removeRole") {
        const res = await newRequest.delete(`/adUserRole/del/${objectToAction.object_id}`);
        await newRequest.post(
          "/trace/add",
          {
            trc_action_on: "User",
            trc_doc_type: "User",
            trc_doc_no: userData?.usr_un,
            trc_aent_code: "",
            trc_ent_code: "",
            trc_action: "amended",
            trc_remarks: `Removed role ${objectToAction?.param1}`,
            trc_tags: [`Removed role ${objectToAction?.param1}`],
            trc_doc_docid: userDocId,
          }
        );
        await fetchUserTrace(userDocId);
        if (res.data?.msg === "removed") {
          setUserRoles((prevData) => prevData.filter(doc => doc?._id !== objectToAction?.object_id));
          showToast("Removed!", "success");
        } else {
          showToast("Error deleting report!", "error");
        }
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleSetUserData = (name, value) => {
    setUserData((prev) => {
      return { ...prev, [name]: value };
    });
  };


  const saveRecord = async (e) => {
    // e.preventDefault();
    try {
      if (!userData?.usr_full_name) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter full name!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!userData?.usr_email) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter email!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!userData?.usr_phone_no) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter phone number!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!userData?.usr_unit_code) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please assign a business unit!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!userData?.usr_profile_code) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please assign a profile!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      // console.log(`currencyAction ... ${currencyAction}`);
      // validate user data
      if (userDocId === "new" || userDocId === undefined) {
        if (!userPw) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please enter password!`);
          setIsNotifyDialogOpen(true);
          return;
        }

        if (!userConfirmPw) {
          setNotifyDialogTitle("Note!");
          setNotifyDialogText(`Please confirm password!`);
          setIsNotifyDialogOpen(true);
          return;
        }

        const res = await newRequest.post(
          "/adUser/validate",
          {
            usr_un: userData?.usr_un,
            usr_full_name: userData?.usr_full_name,
            usr_email: userData?.usr_email,
            usr_phone_no: userData?.usr_phone_no,
            usr_unit_code: userData?.usr_unit_code,
            usr_profile_code: userData?.usr_profile_code,
          }
        );

        // console.log(`validate  ${JSON.stringify(res.data, null, 2)}`);

        if (res.data.length > 0) {
          setCreateUserErrors(res.data);
          setErrorDialogTitle("Oops. a few issues occured!");
          setIsErrorsDialogOpen(true);
          return;
        } else {
          // validate passwords
          if (userPw !== userConfirmPw) {
            setNotifyDialogText("Provided passwords do not match");
            setIsNotifyDialogOpen(true);
            return;
          }
        }
        // if validation has passed register the user
        const regUser = await newRequest.post(
          "/auth/register",
          {
            usr_pw: userConfirmPw,
            ...userData,
            usr_favourite_menus: usrFavouriteMenus || [],
            usr_widgets: usrWidgets || [],
            usr_entity_code: userData?.usr_sub_agent === "Y" ? userData?.usr_entity_code : null
          }
        );

        // console.log(`regUser  ${JSON.stringify(regUser.data, null, 2)}`);
        // setUsers((prevData) => [...prevData, regUser.data]);

        await fetchUser(regUser.data?.doc?._id);
        navigate(`/user/${regUser.data?.doc?._id}`, { replace: true });
        showToast(`Great. ${regUser.data?.doc?.usr_full_name} created!`, "success");
      } else {

        setIsProcessing(true);

        // if image is selected, upload it and get URL
        let profileUrl = "";
        if (img) {
          if (uploadTarget === "firebase") {
            profileUrl = await uploadToFirebase(img, "user-profiles");
          } else {
            profileUrl = await uploadToBackend(img, "user-profiles");
          }
        }

        // update user details
        await newRequest.post(
          "/adUser/upd",
          {
            user_docid: userDocId,
            ...userData,
            usr_photo_url: profileUrl ? profileUrl : userData?.usr_photo_url,
            usr_favourite_menus: usrFavouriteMenus || [],
            usr_widgets: usrWidgets || [],
            usr_entity_code: userData?.usr_sub_agent === "Y" ? userData?.usr_entity_code : null,
            usr_service_type: userData?.usr_sub_agent === "Y" ? userData?.usr_service_type : null,
          }
        );
        // setUsers((prevData) => [...prevData, res.data?.doc]);
        await fetchUserTrace(userDocId);
        showToast(`Saved!`, "success");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const uploadToFirebase = async (file, fileFolder) => {
    setIsUploadDialogOpen(true);
    const storage = getStorage(app);
    const fileName = new Date().getTime() + file.name;
    const fileExtension = file.name.split(".").pop();
    const fileType = file.type;
    const fileSizeKB = file.size / 1024;
    const storageRef = ref(
      storage,
      `qc_${currentUser.usr_org_code}/${fileFolder}/${fileName}`
    );
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(Math.round(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        setIsUploadDialogOpen(false);
        console.log(error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        setIsUploadDialogOpen(false);
        return downloadURL;
        // const res = await newRequest.post(
        //   "/adUser/upd",
        //   {
        //     user_docid: userDocId,
        //     usr_photo_url: downloadURL,
        //   }
        // );

        // const updatedData = [...users];
        // const currentRow = updatedData[selectedUserIndex];
        // currentRow["usr_photo_url"] = downloadURL;
        // setUsers(updatedData);
        // setUsrPhotoUrl(downloadURL)
        // setImg("");
        // setIsUploadDialogOpen(false);

      }
    );
  };


  const uploadToBackend = async (file, fileFolder) => {
    const formData = new FormData();
    // metadata the backend can use to organize + save DB record
    formData.append("orgCode", currentUser.usr_org_code);
    formData.append("folder", fileFolder);
    formData.append("documentType", "User");
    formData.append("documentNo", userDocId);
    formData.append("documentId", userDocId);
    formData.append("userCode", currentUser.usr_id);

    // IMPORTANT append file LAST
    formData.append("file", file);

    // optional: progress bar (axios supports onUploadProgress)
    const res = await newRequest.post("/uploadFiles/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evt) => {
        if (!evt.total) return;
        const progress = (evt.loaded / evt.total) * 100;
        setUploadProgress(Math.round(progress));
      },
    });

    await newRequest.post("/adUser/upd", { user_docid: userDocId, usr_photo_url: res.data?.file?.fl_path, });
    return res.data;
  };

  useEffect(() => {
    if (docid) {
      setUserDocId(docid);
    }
  }, [docid]);

  useEffect(() => {
    if (userDocId === "new" || userDocId === undefined) {
      setUserData({
        usr_enabled: "Y",
      });
      if (userFullNameRef.current) {
        userFullNameRef.current.focus();
      }
    } else {
      fetchUser(userDocId);
    }
    fetchProfiles();
    fetchBranches();
    fetchServiceTypes();
  }, [userDocId]);


  return (
    <div className="ad-user">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="ad-user-main-wrapper">
          <div className="single-user-wrapper">
            <div className="user-center-wrapper">
              <div className="user-center-details">
                <div className="user-center-navbar">
                  <div className="user-navbar-left">
                    <h1 className="page-title">
                      {userData?.usr_full_name?.toUpperCase() || t('newUser').toUpperCase()}
                    </h1>
                  </div>
                  <div className="user-navbar-right">
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#00D37F"
                      tooltip="Save changes"
                      endIcon={<FaSave />}
                      onClick={saveRecord}
                    >
                      {t('save')}
                    </CustomLoadingButton>
                    {userDocId !== "new" &&
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        borderRadiusType="both"
                        variant="tint"
                        color="#2563EB"
                        tooltip="Run reports for this user"
                        endIcon={<IoDocumentTextSharp />}
                        onClick={() => setReportsDialogOpen(true)}>
                        {t('reports')}
                      </CustomLoadingButton>}
                    <CustomLoadingButton
                      currentTheme={currentTheme}
                      iconPosition="end"
                      borderRadiusType="both"
                      variant="tint"
                      color="#f55656"
                      tooltip="Close this form"
                      endIcon={<IoClose />}
                      onClick={() => { navigate(-1) }}>
                      {t('close')}
                    </CustomLoadingButton>
                  </div>
                </div>
                <ExpandableComponent
                  title={t('basicInformation').toUpperCase()}
                  subtitle={""}
                  defaultExpanded={true}
                >
                  {/* <hr className="separator-h" /> */}
                  <div className="form-details-wrapper">
                    <div className="form-details-left">
                      <div className="input-item-with-label">
                        <label
                          htmlFor="usr_full_name"
                          style={{
                            width: "130px",
                          }}
                        >
                          {t('name').toUpperCase()}
                        </label>
                        <input
                          ref={userFullNameRef}
                          id="usr_full_name"
                          name="usr_full_name"
                          type="text"
                          placeholder={t('name').toUpperCase()}
                          value={userData?.usr_full_name}
                          onChange={(e) => handleSetUserData("usr_full_name", e.target.value)}
                          className="form-input-item"
                          style={{ width: "400px" }}
                          disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="usr_profile_code"
                          style={{
                            width: "130px",
                          }}
                        >
                          {t('profile').toUpperCase()}
                        </label>
                        <Select
                          id="usr_profile_code"
                          name="usr_profile_code"
                          menuPortalTarget={document.body}
                          styles={{
                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                            menuPortal: base => ({
                              ...base,
                              zIndex: 9999,
                            })
                          }}
                          width="400px"
                          value={profiles.find(option => option.value === userData?.usr_profile_code) || null}
                          onChange={selectedOption => handleSetUserData("usr_profile_code", selectedOption?.value)}
                          options={profiles}
                          isSearchable={true}
                          placeholder={t('profile').toUpperCase()}
                          isDisabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      <div
                        style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}
                      >
                        <div className="input-item-with-label">
                          <label
                            htmlFor="usr_phone_no"
                            style={{
                              width: "130px",
                            }}
                          >
                            {t('phoneNo').toUpperCase()}
                          </label>
                          <input
                            id="usr_phone_no"
                            name="usr_phone_no"
                            type="text"
                            placeholder={t('phoneNo').toUpperCase()}
                            value={userData?.usr_phone_no}
                            onChange={(e) => handleSetUserData("usr_phone_no", e.target.value)}
                            className="form-input-item"
                            style={{ width: "150px" }}
                            disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          />
                        </div>
                        <div
                          className="input-item-with-label"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <label
                            htmlFor="usr_unit_code"
                            style={{ width: "75px" }}
                          >
                            {t('bizUnit').toUpperCase()}
                          </label>
                          <Select
                            id="usr_unit_code"
                            name="usr_unit_code"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="170px"
                            value={branches.find(option => option.value === userData?.usr_unit_code) || null}
                            onChange={selectedOption => handleSetUserData("usr_unit_code", selectedOption?.value)}
                            options={branches}
                            isSearchable={true}
                            placeholder={t('bizUnit').toUpperCase()}
                            isDisabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          />
                        </div>
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="usr_email"
                          style={{ width: "130px" }}
                        >
                          {t('email').toUpperCase()}
                        </label>
                        <input
                          id="usr_email"
                          name="usr_email"
                          type="email"
                          placeholder={t('email').toUpperCase()}
                          value={userData?.usr_email}
                          onChange={(e) => handleSetUserData("usr_email", e.target.value)}
                          className="form-input-item"
                          style={{ width: "400px" }}
                          onBlur={(e) => {
                            try {
                              if (!userData?.usr_un) {
                                handleSetUserData("usr_un", e.target.value)
                              }
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="usr_title"
                          style={{ width: "130px" }}
                        >
                          {t('title').toUpperCase()}
                        </label>
                        <input
                          id="usr_title"
                          name="usr_title"
                          type="text"
                          placeholder={t('title').toUpperCase()}
                          value={userData?.usr_title}
                          onChange={(e) => handleSetUserData("usr_title", e.target.value)}
                          className="form-input-item"
                          style={{ width: "400px" }}
                          disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      <div className="input-item-with-label">
                        <label
                          htmlFor="usr_un"
                          style={{ width: "130px" }}
                        >
                          {t('username').toUpperCase()}
                        </label>
                        <input
                          id="usr_un"
                          name="usr_un"
                          type="text"
                          placeholder={t('username').toUpperCase()}
                          value={userData?.usr_un}
                          onChange={(e) => handleSetUserData("usr_un", e.target.value)}
                          className="form-input-item"
                          style={{ width: "400px" }}
                          disabled={userDocId !== "new" || !["admin", "superadmin"].includes(currentUser.user_type_xx)}
                        />
                      </div>
                      {userDocId === "new" && (
                        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                          <div className="input-item-with-label">
                            <label
                              htmlFor="user_pw"
                              style={{ width: "130px" }}
                            >
                              {t('password').toUpperCase()}
                            </label>
                            <input
                              id="user_pw"
                              name="user_pw"
                              type="password"
                              placeholder={t('password').toUpperCase()}
                              value={userPw}
                              onChange={(e) => setUserPw(e.target.value)}
                              className="form-input-item"
                              style={{ width: "160px" }}
                            />
                          </div>
                          <div
                            className="input-item-with-label"
                            style={{ justifyContent: "flex-end" }}
                          >
                            <label
                              htmlFor="user_confirm_pw"
                              style={{ width: "max-content" }}
                            >
                              {t('confirm').toUpperCase()}
                            </label>
                            <input
                              id="user_confirm_pw"
                              name="user_confirm_pw"
                              type="password"
                              placeholder={t('confirm').toUpperCase()}
                              value={userConfirmPw}
                              onChange={(e) => setUserConfirmPw(e.target.value)}
                              className="form-input-item"
                              style={{ width: "160px" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="form-details-right">
                      <div className="logo">
                        {userData?.usr_photo_url ?
                          <img src={userData?.usr_photo_url} alt="" className="img" />
                          :
                          <InitialsAvatar
                            name={userData?.usr_full_name || ""}
                            size={120}
                            currentTheme={currentTheme}
                          />}
                        <input
                          type="file"
                          id="file"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={(e) => setImg(e.target.files[0])}
                        />
                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                          <label htmlFor="file">
                            <div className="item" style={{ cursor: "pointer" }}>
                              <span>{t('selectImage')}</span>
                            </div>
                          </label>}
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%", paddingLeft: "10px" }}>
                        <ToggleSwitch
                          id="usr_enabled"
                          value={userData?.usr_enabled}
                          onChange={(val) => handleSetUserData("usr_enabled", val)}
                          label={t('enabled').toUpperCase()}
                          labelPosition="end"
                          labelWidth="max-content"
                          disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          border="N"
                          style={{
                            width: "max-content",
                          }}
                        />
                        {/* <ToggleSwitch
                        id="usr_check_device"
                        value={userData?.usr_check_device}
                        onChange={(val) => handleSetUserData("usr_check_device", val)}
                        label={t('deviceCheck').toUpperCase()}
                        labelPosition="end"
                        labelWidth="max-content"
                        disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                        border="N"
                        style={{
                          width: "max-content",
                        }}
                      /> */}
                      </div>
                    </div>
                  </div>
                  {userDocId !== "new" &&
                    ["admin", "superadmin"].includes(currentUser?.user_type_xx) &&
                    <hr className="separator-h" />}
                  {userDocId !== "new" &&
                    ["admin", "superadmin"].includes(currentUser?.user_type_xx) &&
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        margin: "10px 0px",
                        justifyContent: "flex-start",
                      }}
                    >
                      <ToggleSwitch
                        id="usr_sub_agent"
                        value={userData?.usr_sub_agent}
                        onChange={(val) => handleSetUserData("usr_sub_agent", val)}
                        label={t('externalUser').toUpperCase()}
                        labelPosition="end"
                        labelWidth="max-content"
                        disabled={!["admin", "superadmin"].includes(currentUser?.user_type_xx)}
                        border="N"
                        style={{ width: "max-content", marginLeft: "130px" }}
                      />
                      {userData?.usr_sub_agent === "Y" &&
                        <div className="input-item-with-label">
                          <label
                            htmlFor="usr_entity_code"
                            style={{
                              width: "130px",
                            }}
                          >
                            {t('entity').toUpperCase()}
                          </label>
                          <AsyncSelect
                            id="usr_entity_code"
                            name="usr_entity_code"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="400px"
                            value={{
                              value: userData?.usr_entity_code,
                              label: userData?.entity_name_xx
                            }}
                            onChange={selectedOption => {
                              try {
                                handleSetUserData("usr_entity_code", selectedOption?.value);
                                handleSetUserData("entity_name_xx", selectedOption?.label);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            loadOptions={fetchClientsBySearch}
                            isSearchable={true}
                            isDisabled={userDocId === "new"}
                            placeholder={t('entity').toUpperCase()}
                            noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                          />
                        </div>}

                      {userData?.usr_sub_agent === "Y" &&
                        <div className="input-item-with-label">
                          <label
                            htmlFor="usr_service_type"
                            style={{
                              width: "130px",
                            }}
                          >
                            {t('serviceType').toUpperCase()}
                          </label>
                          <Select
                            id="usr_service_type"
                            name="usr_service_type"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="400px"
                            value={entityServices.find(option => option.value === userData?.usr_service_type) || null}
                            onChange={selectedOption => handleSetUserData("usr_service_type", selectedOption?.value)}
                            options={entityServices}
                            isSearchable={true}
                            placeholder={t('serviceType').toUpperCase()}
                            isDisabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                          />
                        </div>}
                    </div>}
                </ExpandableComponent>
                <ExpandableComponent
                  title={t('assignedRoles').toUpperCase()}
                  subtitle={
                    userDocId !== "new" &&
                    ["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                    <CircularButton currentTheme={currentTheme}
                      onClick={async () => {
                        try {
                          await fetchRoles();
                          setShowAddRoles(true);
                        } catch (error) {
                          console.log(error);
                        }
                      }} icon={<MdAdd />} width={"30px"} height={"30px"} />}
                  defaultExpanded={true}
                >
                  <div className="user-roles-wrapper">
                    {userRoles?.map((row, index) => (
                      <div key={row?._id} className="single-item">
                        <span className="sub-title">{index + 1}.</span>
                        <span className="sub-title">{`${row?.role_name_xx}`}</span>
                        {["admin", "superadmin"].includes(currentUser?.user_type_xx) &&
                          <CircularButton currentTheme={currentTheme}
                            onClick={() => {
                              try {
                                setObjectToAction({
                                  object_id: row?._id,
                                  action_text: `Do remove ${row?.role_name_xx} from ${userData?.usr_full_name}?`,
                                  param1: row?.role_name_xx
                                });
                                setConfirmDialogAction("removeRole");
                                setIsConfirmDialogOpen(true);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            color="#E53935"
                            icon={<MdDelete />}
                            width={"30px"}
                            height={"30px"} />
                        }
                      </div>
                    ))}
                  </div>
                </ExpandableComponent>
                <ExpandableComponent
                  title={t('userSignatures').toUpperCase()}
                  subtitle={""}
                  defaultExpanded={true}
                >
                  <AdUserSign />
                </ExpandableComponent>
              </div>
            </div>
            <div className="right-wrapper">
              <div className="right-content">
                {/* <WorkedOnBy name={selectedUser?.updated_by_name_xx} photoUrl={selectedUser?.updated_by_photo_url_xx} time_ago_xx={selectedUser?.time_ago_xx} /> */}
                <h1 className="sub-title">{t('timeline').toUpperCase()}</h1>
                <div className="timeline-root">
                  {userTraceData.map((item) => (
                    <div key={item?._id} className="timeline-item">
                      <div className="timeline-separator">
                        <div className="timeline-dot"></div>
                        <div className="timeline-connector"></div>
                      </div>
                      <div className="timeline-content">
                        <div className="timeline-navbar">
                          <div className="avatar-container">
                            {item?.updated_by_photo_url_xx ?
                              <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" /> : <CiImageOn style={{ width: "30px", height: "30px" }} />}
                            <span className="username">{item?.updated_by_name_xx}</span>
                          </div>
                          <span className="time-ago">{item?.time_ago_xx}</span>
                        </div>
                        <div className="remarks">
                          {item?.trc_remarks}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* errors on user creation*/}
      <Dialog open={isErrorsDialogOpen} onClose={() => setIsErrorsDialogOpen(false)}>
        <DialogTitle>{errorDialogTitle}</DialogTitle>
        <DialogContent>
          {createUserErrors.map((row, index) => (
            <div
              key={row?._id}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginRight: "5px",
                  }}
                >
                  {index + 1}.
                </span>
                <span dangerouslySetInnerHTML={{ __html: row?.text }} />
              </div>
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsErrorsDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p dangerouslySetInnerHTML={{ __html: objectToAction?.action_text }} />}
      />
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: userData?.usr_un,
                  docType: "User",
                  docId: userDocId,
                  username: userData?.usr_un,
                  userFullName: userData?.usr_full_name,
                  userEmail: userData?.usr_email,
                  clientEmail: "",
                  clientEntCode: "",
                  clientEntName: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {showAddRoles && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{t('roles').toUpperCase()}</span>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setShowAddRoles(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="table-content" style={{ width: "600px" }}>
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "400px" }}>
                          <div className="search-input-wrapper" style={{ width: "90%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={t('search')}
                              value={searchTermRole}
                              onChange={(e) => setSearchTermRole(e.target.value)}
                            />
                            {searchTermRole.length > 0 && (
                              <MdClose
                                onClick={(e) => setSearchTermRole("")}
                                className="search-input-icon"
                              />
                            )}
                            {searchTermRole.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('action').toUpperCase()}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {systemRoles
                        ?.filter(
                          (row) =>
                            row?.role_code.toLowerCase().includes(searchTermRole.toLowerCase()) ||
                            row?.role_name.toLowerCase().includes(searchTermRole.toLowerCase())
                        )
                        .map((row, index) => (
                          <TableRow
                            key={row?._id}
                            className={`${selectedRole?._id === row._id ? "tablerow current" : "tablerow"}`}
                            onClick={async () => {
                              try {
                                setSelectedRole(row);
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <h1 className="normal-title">{index + 1}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "400px" }}>
                              <h1 className="sub-title">{row?.role_name}</h1>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <CircularButton currentTheme={currentTheme}
                                onClick={async (e) => {
                                  try {
                                    const res = await newRequest.post(
                                      "/adUserRole/add",
                                      {
                                        ur_user_docid: userDocId,
                                        ur_role_code: row?.role_code,
                                        ur_display_order: userRoles?.length + 1 || 0
                                      }
                                    );

                                    if (res.data.msg === "added") {
                                      await newRequest.post(
                                        "/trace/add",
                                        {
                                          trc_action_on: "User",
                                          trc_doc_type: "User",
                                          trc_doc_no: userData?.usr_un,
                                          trc_aent_code: "",
                                          trc_ent_code: "",
                                          trc_action: "amended",
                                          trc_remarks: `Assigned role ${row?.role_name}`,
                                          trc_tags: [`Assigned role ${row?.role_name}`],
                                          trc_doc_docid: userDocId
                                        }
                                      );
                                      setUserRoles((prevData) => [...prevData, res.data?.doc]);
                                      showToast("Added!", "success");
                                      await fetchUserTrace(userDocId);
                                    } else if (res.data.msg === "exists") {
                                      showToast(`Role ${row?.role_name} already assigned`, "error");
                                    } else {
                                      showToast(`Unable to add role`, "error");
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                icon={<MdAdd />} width={"35px"} height={"35px"} />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {isOverlayOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span>{t('help').toUpperCase()}</span>
              <CircularButton onClick={() => setIsOverlayOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <VideoPlayer videoUrl="https://www.youtube.com/embed/PPCfDe8TfJQ" />
            </div>
            <div className="overlay-actions">
            </div>
          </div>
        </motion.div>
      )}
      {/* progress dialog for file upload  */}
      <UploadDialog
        open={isUploadDialogOpen}
        handleClose={() => setIsUploadDialogOpen(false)}
        uploadProgress={uploadProgress}
      />
    </div>
  );
};

const UploadDialog = ({ open, handleClose, uploadProgress }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Progress</DialogTitle>
      <DialogContent>
        <LinearProgress variant="determinate" value={uploadProgress} />
        {uploadProgress && <p>{uploadProgress}% Complete</p>}
      </DialogContent>
    </Dialog>
  );
};

export default AdUser;
